export const getPricingPlanIdx = (pricingPlanName) => (["free", "pro", "team", "business", "enterprise"].indexOf(pricingPlanName))